export default "__VITE_ASSET__DVI9tSRr__"